import React, { useMemo } from "react";

export type BackendItemLowStock = {
    id: string;
    name: string;
    currentStock: string | number;
    minimumStock: string | number;
    companyId?: string;
};

export type LowStockAlertProps = {
    title?: string;
    items?: BackendItemLowStock[];
    loading?: boolean;
    error?: string | null;
    className?: string;
    height?: number; // visual alto mínimo
};

const fmtQty = (n: number) =>
    new Intl.NumberFormat("es-ES", { maximumFractionDigits: 0 }).format(n);

export const LowStockAlertCard: React.FC<LowStockAlertProps> = ({
                                                                    title = "Atención: Productos con stock por debajo del mínimo",
                                                                    items = [],
                                                                    loading = false,
                                                                    error = null,
                                                                    className = "",
                                                                    height = 140,
                                                                }) => {
    const data = useMemo(() => {
        return (items || [])
            .map((it) => ({
                id: it.id,
                name: it.name,
                current: Number.parseFloat(String(it.currentStock)) || 0,
                min: Number.parseFloat(String(it.minimumStock)) || 0,
                deficit: (Number.parseFloat(String(it.minimumStock)) || 0) - (Number.parseFloat(String(it.currentStock)) || 0),
            }))
            .filter((x) => x.current < x.min) // solo bajo mínimos
            .sort((a, b) => b.deficit - a.deficit);
    }, [items]);

    const noData = !loading && !error && data.length === 0;

    return (
        <div className={`rounded-2xl border bg-white shadow-sm ${className}`} style={{ minHeight: height }}>
            <div className="p-4 flex items-center justify-between">
                <h3 className="font-semibold">{title}</h3>
                <span className="text-xs text-gray-600">Alertas</span>
            </div>

            <div className="px-4 pb-4">
                {loading ? (
                    <div className="p-3 text-sm text-gray-500">Cargando alertas…</div>
                ) : error ? (
                    <div className="p-3 text-sm text-rose-600">{error}</div>
                ) : noData ? (
                    <div className="p-3 text-sm text-gray-500">No hay alertas de stock mínimo.</div>
                ) : (
                    <ul className="space-y-2">
                        {data.map((p) => (
                            <li
                                key={p.id}
                                className="flex items-center justify-between rounded-xl border bg-amber-50/70 px-3 py-2"
                            >
                                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center rounded-md bg-amber-500/15 text-amber-700 text-[11px] px-2 py-0.5 font-medium">
                    BAJO STOCK
                  </span>
                                    <span className="font-medium">{p.name}</span>
                                </div>
                                <div className="text-sm text-gray-700">
                                    Stock actual: <b>{fmtQty(p.current)}</b> · Mínimo: <b>{fmtQty(p.min)}</b> · Falta:{" "}
                                    <b className="text-amber-700">{fmtQty(Math.max(p.deficit, 0))}</b>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};
